export function addGlobalMessage(payload) {
    return (dispatch) => {
        dispatch({
            type: "ADD_MESSAGE",
            payload
        });
    };
}

export function clearGlobalMessage() {
    return (dispatch) => {
        dispatch({
            type: "CLEAR_MESSAGES"
        });
    };
}
